import React, { ChangeEventHandler } from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import styles from '../styles/dateTypeSelector.module.scss'

interface DateTypeSelectorProps {
  value: string | null;
  onChange: (value: {value: string, label: string}) => void;
}

const dateOptions = [
  { value: 'issuedDate', label: 'Fecha de expedición de la factura' },
  { value: 'filingDate', label: 'Fecha de radicación de la factura' },
  { value: 'attentionDate', label: 'Fecha de prestación del servicio' },
  { value: 'auditDate', label: 'Fecha de asignación a auditoría' },
  { value: 'conciliatedDate', label: 'Fecha de consolidación de auditoría' },
];

const DateTypeSelector: React.FC<DateTypeSelectorProps> = ({ value, onChange }) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOption = dateOptions.find(option => option.value === event.target.value);
    if (selectedOption) {
      onChange(selectedOption);
    }
  };

  return (
    <div className={styles.container}>
      <label htmlFor={"date-type-select"}>
          Seleccionar Fecha
      </label>
      <select 
          name={"date-type-select"}
          id={"date-type-select"}
          data-testid={"date-type-select"}
          value={value || ''}
          onChange={handleChange}
      >
        <option value="" disabled hidden>
          Tipo de fecha a aplicar
        </option>
        {
            dateOptions.map((opcion) => (
                <option key={opcion.value} value={opcion.value} data-testid={`option-select-${opcion.value}`}>
                    {opcion.label}
                </option>
            ))
        }
      </select>
    </div>
  );
};

export default DateTypeSelector;